import at from '../actionTypes'
import createReducer from './utilities/createReducer'
import icons from '../../enums/icons'
import { getLocalisedMessage } from '../../utilities/Errors/index'
import that from '../../utilities/translationHelper'
import showAppMessage from './utilities/showAppMessage'
import getField from '../../utilities/Data/getField'
import Item from '../../utilities/Data/Item'
import Kit from '../../utilities/Data/Kit'
import User from '../../utilities/Data/User'

const isOwnProfile = (state, userProfile) => (userProfile || state.userProfile || {}).uid === state.user.uid

export default createReducer({}, {
	/* User profile being viewed */
	[at.userProfileFetch_Begin]: state => ({
		...state,
		userName: undefined,
		userNameNotFound: false,
		userProfile: undefined,
		userProfileKits: undefined
	}),
	[at.userProfileFetch_Success]: (state, action) => {
		const userProfile = action.payload.userProfile
		return {
			...state,
			userProfile,
			heading: {
				text: userProfile.fullName,
				icon: icons.whiteUser
			}
		}
	},
	[at.userProfileFetch_Fail]: (state, action) => ({
		...state,
		userName: action.payload.userName,
		userNameNotFound: true
	}),
	[at.userProfilePostsFetch_Success]: (state, action) => ({
		...state,
		userProfilePosts: action.payload.posts
	}),
	[at.userProfileKitsFetch_Success]: (state, action) => ({
		...state,
		userProfileKits: action.payload.kits
	}),
	[at.userProfileKitsOwnedFetch_Success]: (state, action) => ({
		...state,
		userProfileKitsOwned: action.payload.kitsOwned
	}),
	[at.userProfileKitsWantedFetch_Success]: (state, action) => ({
		...state,
		userProfileKitsWanted: action.payload.kitsWanted
	}),
	[at.userProfileItemsOwnedFetch_Success]: (state, action) => ({
		...state,
		userProfileItemsOwned: action.payload.itemsOwned,
		user: {
			...state.user,
			...(!!isOwnProfile(state, action.payload.userProfile) && { userProfileItemsOwned: action.payload.itemsOwned })
		}
	}),
	[at.userProfileItemsWantedFetch_Success]: (state, action) => ({
		...state,
		userProfileItemsWanted: action.payload.itemsWanted,
		user: {
			...state.user,
			...(!!isOwnProfile(state, action.payload.userProfile) && { userProfileItemsWanted: action.payload.itemsWanted })
		}
	}),
	[at.userProfileFollowersFetch_Success]: (state, action) => ({
		...state,
		userProfilePublicFollowers: action.payload.followers
	}),
	[at.userProfileFollowingFetch_Success]: (state, action) => ({
		...state,
		userProfilePublicFollowing: action.payload.following
	}),
	[at.userProfileKitAdd_Success]: (state, action) => (isOwnProfile(state) ? {
		...state,
		userProfileKits: state.userProfileKits ? [...state.userProfileKits, action.payload.kit] : [action.payload.kit]
	} : state),
	// add the fetched kit to the list (it has filled items)
	[at.kitFetch_Success]: (state, action) => (state.userProfileKits && state.userProfileKits.some(kit => kit.kitId === action.payload.kitId) ? {
		...state,
		userProfileKits: [...(state.userProfileKits || []).filter(kit => kit.kitId !== action.payload.kitId), action.payload.kit]
	} : state),
	// just put the already fetched user's profile in the state for display
	[at.userProfileGetOwnProfile]: (state) => {
		const userProfile = {
			...state.user.userProfile
		}
		return {
			...state,
			userProfile,
			heading: {
				text: userProfile.fullName,
				icon: icons.whiteUser
			}
		}
	},

	[at.userProfileFollowingRemove_Success]: (state, action) => {
		let countFollowing = getField(state, 'userProfile.countFollowing') || 0
		countFollowing = action.payload.isFollowing ? countFollowing + 1 : countFollowing - 1
		let userProfilePublicFollowing = state.userProfilePublicFollowing || []
		if (action.payload.isFollowing) {
			userProfilePublicFollowing.push({
				...state.user.userProfile,
				realName: state.user.userProfile.firstName || state.user.userProfile.fullName
			})
		} else {
			userProfilePublicFollowing = userProfilePublicFollowing.filter(upp => upp.uid !== action.payload.uid)
		}
		return {
			...state,
			userProfilePublicFollowing,
			userProfile: {
				...state.userProfile,
				countFollowing,
				isFollowing: action.payload.isFollowing
			}
		}
	},

	[at.userProfileFollowingRemove_Fail]: state => (state.userProfile ? ({
		...state,
		userProfile: {
			...state.userProfile // re-set the same profile (following particularly) - so the user (the following state particularly) re-renders (resetting the optimistic UI update)
		}
	}) : state),

	[at.userProfileFollowerRemove_Success]: (state, action) => {
		let countFollowers = getField(state, 'userProfile.countFollowers') || 0
		countFollowers = action.payload.isFollowing ? countFollowers + 1 : countFollowers - 1
		let userProfilePublicFollowers = state.userProfilePublicFollowers || []
		if (action.payload.isFollowing) {
			userProfilePublicFollowers.push({
				...state.user.userProfile,
				realName: state.user.userProfile.firstName || state.user.userProfile.fullName
			})
		} else {
			userProfilePublicFollowers = userProfilePublicFollowers.filter(upp => upp.uid !== action.payload.follower.uid)
		}
		return {
			...state,
			userProfilePublicFollowers,
			userProfile: {
				...state.userProfile,
				countFollowers
			}
		}
	},

	[at.userProfileFollowerRemove_Fail]: state => (state.userProfile ? ({
		...state,
		userProfile: {
			...state.userProfile // re-set the same profile (following particularly) - so the user (the following state particularly) re-renders (resetting the optimistic UI update)
		}
	}) : state),

	[at.userProfileFollowersSet_Success]: (state, action) => {
		let countFollowers = getField(state, 'userProfile.countFollowers') || 0
		countFollowers = action.payload.isFollowing ? countFollowers + 1 : countFollowers - 1
		let userProfilePublicFollowers = state.userProfilePublicFollowers || []
		if (action.payload.isFollowing) {
			userProfilePublicFollowers.push({
				...state.user.userProfile,
				realName: state.user.userProfile.firstName || state.user.userProfile.fullName
			})
		} else {
			userProfilePublicFollowers = userProfilePublicFollowers.filter(upp => upp.uid !== state.user.uid)
		}
		return {
			...state,
			userProfilePublicFollowers,
			userProfile: {
				...state.userProfile,
				countFollowers,
				isFollowing: action.payload.isFollowing
			}
		}
	},

	[at.userProfileFollowersSet_Fail]: state => (state.userProfile ? ({
		...state,
		userProfile: {
			...state.userProfile // re-set the same profile (following particularly) - so the user (the following state particularly) re-renders (resetting the optimistic UI update)
		}
	}) : state),

	[at.userProfileVerifiersFetch_Success]: (state, action) => ({
		...state,
		userProfilePublicVerifiers: action.payload.verifiers
	}),
	[at.userProfileVerifiedFetch_Success]: (state, action) => ({
		...state,
		userProfilePublicVerified: action.payload.verified
	}),
	[at.userProfileVerifiersSet_Success]: (state, action) => {
		let countVerifiers = getField(state, 'userProfile.countVerifiers') || 0
		countVerifiers = action.payload.hasVerified ? countVerifiers + 1 : countVerifiers - 1
		let userProfilePublicVerifiers = state.userProfilePublicVerifiers || []
		userProfilePublicVerifiers = userProfilePublicVerifiers.filter(upp => upp.uid !== state.user.uid)
		if (action.payload.hasVerified) {
			userProfilePublicVerifiers.push({
				...state.user.userProfile,
				realName: state.user.userProfile.firstName || state.user.userProfile.fullName
			})
		}
		return {
			...state,
			userProfilePublicVerifiers,
			userProfile: {
				...state.userProfile,
				countVerifiers,
				hasVerified: action.payload.hasVerified,
				relationshipType: action.payload.relationshipType
			}
		}
	},

	[at.userProfileVerifiersSet_Fail]: state => (state.userProfile ? ({
		...state,
		userProfile: {
			...state.userProfile // re-set the same profile (resetting optimistic UI update)
		}
	}) : state),

	/* User's own profile */

	[at.userProfileSuggest]: (state, action) => {
		const { userProfile } = action.payload
		const updatedUser = {
			...state.user,
			suggestedUserProfile: userProfile
		}
		if (userProfile && userProfile.uid === state.user.uid) {
			updatedUser.userProfile = userProfile
		}
		return userProfile ? {
			...state,
			user: updatedUser
		} : state
	},

	[at.userProfileOnboardSubmit]: (state, action) => {
		const userProfile = {
			...state.user.userProfile,
			...action.payload.values,
			onboardingComplete: true,
			algoliaProcessingRequired: (
				// we have a value for fullName and userName
				(action.payload.values.fullName || state.user.userProfile.fullName) &&
				(action.payload.values.userName || state.user.userProfile.userName) && (
					// it's changing
					!state.user.userProfile ||
					state.user.userProfile.fullName !== action.payload.values.fullName ||
					state.user.userProfile.userName !== action.payload.values.userName
				)
			)
		}
		delete userProfile.onboardingSuggestedUserNames

		return ({
			...state,
			user: {
				...state.user,
				userProfile
			}
		})
	},

	[at.userProfileReserveUserName_Fail]: (state, action) => ({
		...state,
		...showAppMessage(getLocalisedMessage(action.payload.error, that.context.translate('That username is in use. Please choose another.')))
	}),

	[at.userProfileSave_Success]: state => ({
		...state,
		user: {
			...state.user,
			userProfile: {
				...state.user.userProfile,
				algoliaProcessingRequired: false
			}
		}
	}),
	[at.userProfileSave_Fail]: (state, action) => ({
		...state,
		...showAppMessage(getLocalisedMessage(action.payload.error, that.context.translate('There was an error saving the profile')))
	}),

	[at.userProfileUpdateProfilePicture]: (state, action) => ({
		...state,
		user: {
			...state.user,
			userProfile: {
				...state.user.userProfile,
				profileImage: action.payload.profileImage
			}
		},
		currentUserProfileImage: action.payload.profileImage
	}),

	// TODO: ownwant redo fetch following into followingByUid

	[at.userProfileStatisticsUpdate]: (state, action) => ({
		...state,
		user: {
			...state.user,
			userProfile: {
				...state.user.userProfile,
				statistics: {
					...state.user.userProfile.statistics,
					...User.calculateStatistics(action.payload.values)
				}
			}
		}
	}),

	[at.userProfileUpdate]: (state, action) => {
		const result = {
			...state,
			user: {
				...state.user,
				userProfile: {
					...state.user.userProfile,
					...action.payload.userProfile,
					algoliaProcessingRequired: (
						// we have a value for fullName and userName
						(action.payload.userProfile.fullName || state.user.userProfile.fullName) &&
						(action.payload.userProfile.userName || state.user.userProfile.userName) && (
							// it's changing
							!state.user.userProfile ||
							state.user.userProfile.fullName !== action.payload.userProfile.fullName ||
							state.user.userProfile.userName !== action.payload.userProfile.userName
						)
					)
				}
			}
		}

		return result
	},

	[at.userProfileUpdate_Success]: state => ({
		...state,
		user: {
			...state.user,
			userProfile: {
				...state.user.userProfile,
				algoliaProcessingRequired: false
			}
		}
	}),

	[at.userProfileUpdate_Fail]: state => ({
		...state,
		user: {
			...state.user,
			userProfile: {
				...state.user.userProfile,
				algoliaProcessingRequired: false
			}
		}
	}),

	[at.kitOwnWantFetch_Success]: (state, action) => ({
		...state,
		kitOwnById: {
			...state.kitOwnById,
			...action.payload.kitOwnById
		},
		kitWantById: {
			...state.kitWantById,
			...action.payload.kitWantById
		}
	}),

	[at.itemOwnWantFetch_Success]: (state, action) => ({
		...state,
		itemOwnByKey: {
			...state.itemOwnByKey,
			...action.payload.itemOwnByKey
		},
		itemWantByKey: {
			...state.itemWantByKey,
			...action.payload.itemWantByKey
		}
	}),

	[at.itemOwnSet_Success]: (state, action) => ({
		...state,
		itemOwnByKey: {
			...state.itemOwnByKey,
			[action.payload.item.itemKey]: Item.updateItemOwn(state.itemOwnByKey && state.itemOwnByKey[action.payload.item.itemKey], action.payload)
		},
		...(!!isOwnProfile(state) && { userProfileItemsOwned: Item.updateItemsOwned(state.userProfileItemsOwned, action.payload) }),
		user: {
			...state.user,
			userProfileItemsOwned: Item.updateItemsOwned(state.user.userProfileItemsOwned, action.payload)
		}
	}),
	[at.itemWantSet_Success]: (state, action) => ({
		...state,
		itemWantByKey: {
			...state.itemWantByKey,
			[action.payload.item.itemKey]: Item.updateItemWant(state.itemWantByKey && state.itemWantByKey[action.payload.item.itemKey], action.payload)
		},
		...(!!isOwnProfile(state) && { userProfileItemsWanted: Item.updateItemsWanted(state.userProfileItemsWanted, action.payload) }),
		user: {
			...state.user,
			userProfileItemsWanted: Item.updateItemsWanted(state.user.userProfileItemsWanted, action.payload)
		}
	}),
	[at.kitOwnSet_Success]: (state, action) => ({
		...state,
		kitOwnById: {
			...state.kitOwnById,
			[action.payload.kit.kitId]: Kit.updateKitOwn(state.kitOwnById && state.kitOwnById[action.payload.kit.kitId], action.payload)
		},
		...(!!isOwnProfile(state) && { userProfileKitsOwned: Kit.updateKitsOwned(state.userProfileKitsOwned, action.payload) })
	}),
	[at.kitWantSet_Success]: (state, action) => ({
		...state,
		kitWantById: {
			...state.kitWantById,
			[action.payload.kit.kitId]: Kit.updateKitWant(state.kitWantById && state.kitWantById[action.payload.kit.kitId], action.payload)
		},
		...(!!isOwnProfile(state) && { userProfileKitsWanted: Kit.updateKitsWanted(state.userProfileKitsWanted, action.payload) })
	}),

	[at.itemOwnSet_Fail]: state => ({
		...state,
		itemOwnByKey: {
			...state.itemOwnByKey
		}
	}),
	[at.itemWantSet_Fail]: state => ({
		...state,
		itemWantByKey: {
			...state.itemWantByKey
		}
	}),
	[at.kitOwnSet_Fail]: state => ({
		...state,
		kitOwnById: {
			...state.kitOwnById
		}
	}),
	[at.kitWantSet_Fail]: state => ({
		...state,
		kitWantById: {
			...state.kitWantById
		}
	}),

	// some updates for iff the users own profile is the currently viewed one
	[at.kitDuplicate_Success]: state => (isOwnProfile(state) ? {
		...state,
		// optimistic update (only)
		userProfile: {
			...state.userProfile,
			countKitsCreated: (state.userProfile.countKitsCreated || 0) + 1
		}
		// cannot update userProfileKits here, don't have the kit data
	} : state),
	[at.kitDelete_Success]: (state, action) => (isOwnProfile(state) ? {
		...state,
		// optimistic update (only)
		userProfile: {
			...state.userProfile,
			countKitsCreated: state.userProfile.countKitsCreated ? state.userProfile.countKitsCreated - 1 : 0
		},
		userProfileKits: state.userProfileKits && state.userProfileKits.filter(kit => kit.kitId !== action.payload.kitId)
	} : state),
	[at.postSet_Success]: (state, action) => (isOwnProfile(state) ? {
		...state,
		// optimistic update (only if new)
		userProfile: {
			...state.userProfile,
			countPostsCreated: !action.payload.postDraft.postId && state.userProfile.countPostsCreated ? state.userProfile.countPostsCreated + 1 : 1
		},
		userProfilePosts: [
			// insert or replace the post
			{
				...action.payload.postDraft,
				postId: action.payload.postId
			},
			...(state.userProfilePosts || []).filter(post => post.postId !== action.payload.postId)
		]
	} : state),
	[at.kitDraftSet_Success]: (state, action) => (isOwnProfile(state) ? {
		...state,
		// optimistic update (only if new)
		userProfile: {
			...state.userProfile,
			countKitsCreated: !action.payload.kitDraft.kitId && state.userProfile.countKitsCreated ? state.userProfile.countKitsCreated + 1 : 1
		},
		userProfileKits: [
			// insert or replace the kit
			{
				...action.payload.kitDraft,
				kitId: action.payload.kitId
			},
			...(state.userProfileKits || []).filter(kit => kit.kitId !== action.payload.kitId)
		]
	} : state),
	[at.postDelete_Success]: (state, action) => (isOwnProfile(state) ? {
		...state,
		// optimistic update (only)
		userProfile: {
			...state.userProfile,
			countPostsCreated: state.userProfile.countPostsCreated ? state.userProfile.countPostsCreated - 1 : 0
		},
		userProfilePosts: state.userProfilePosts && state.userProfilePosts.filter(post => post.postId !== action.payload.postId)
	} : state),

	[at.VERIFYUSER_SUCCESS]: (state, action) => {
		if (!state.user || !state.user.userProfile) {
			return state
		}

		const verifiedUserObject = action.payload.verifiedUserObject
		verifiedUserObject.alreadyVerified = (state.userProfilePublicVerified || []).some(pp => pp.uid === verifiedUserObject.uid)
		return {
			...state,
			verifiedUserObject
		}
	},

	[at.userProfileVerificationFetch_Success]: (state, action) => {
		const result = {
			...state,
			userProfilesPublic: action.payload.userProfilesPublic.map(upp => ({
				...upp,
				profileImage: upp.images ? upp.images.map(img => img.type === 'twentieth')[0] : null
			}))
		}
		return result
	},

	[at.userProfileTabSet]: (state, action) => ({
		...state,
		user: {
			...state.user,
			tab: action.payload.tab
		}
	}),

	[at.activateNewUser_Begin]: state => ({
		...state,
		userActivationFailed: false,
		userActivationInProgress: true
	}),

	[at.activateNewUser_Fail]: state => ({
		...state,
		userActivationFailed: true,
		userActivationInProgress: false
	}),

	[at.activateNewUser_Success]: (state, action) => {
		const result = {
			...state,
			activateNewUserUid: action.payload.uid
		}

		delete result.userActivationFailed
		delete result.userActivationInProgress
		return result
	}

})



// WEBPACK FOOTER //
// ./src/redux/reducers/userProfileReducer.js